/** What the api's error body looks like: { error: { id, type, message?, sentry } } (see api/src/utils/errors.ts) */
type ApiErrorBody = { error?: { id?: string, type?: string, message?: string, sentry?: string } }

export type ApiErrorDescription = {
  /** Short, human title, e.g. "Sync failed" plus the HTTP status where known */
  title: string,
  /** The api's message when it sent one, otherwise the transport error */
  message: string,
  /** Error type from the api, e.g. errEBulkServerCertificateUntrusted */
  type?: string,
  /** The api's error id, for the log and Sentry */
  id?: string,
}

/** The api refuses a status change the application's current status doesn't allow; its message is a JSON dump (DBS-346) */
const STALE_STATUS_TYPES = ['errEBulkApplicationTransitionNotSupported', 'errEBulkApplicationTransitionConstraintFailed']
export const STALE_STATUS_MESSAGE = "The application's status doesn't allow this step. It may have moved on since the page loaded: refresh the page to see where it stands."

/** Reads an axios/Zodios failure into something a screen can show. Never throws. */
export const describeApiError = (err: unknown, what: string): ApiErrorDescription => {
  const anyErr = err as { response?: { status?: number, data?: ApiErrorBody }, message?: string } | undefined
  const status = anyErr?.response?.status
  const body = anyErr?.response?.data?.error
  return {
    title: status == null ? `${what} failed` : `${what} failed (HTTP ${status})`,
    message: body?.type != null && STALE_STATUS_TYPES.includes(body.type)
      ? STALE_STATUS_MESSAGE
      : body?.message ?? body?.type ?? anyErr?.message ?? 'Unknown error',
    type: body?.type,
    id: body?.id,
  }
}
